import React, { memo, useCallback } from "react";
import { setContent } from "./state/content";
const Trigger = /*#__PURE__*/memo(({
  align,
  trigger,
  children,
  ...props
}) => {
  const onClick = useCallback(({
    pageX,
    pageY
  }) => setContent({
    children,
    align,
    style: {
      top: pageY,
      left: pageX
    }
  }), [align, children]);
  return /*#__PURE__*/React.cloneElement(trigger, {
    onClick,
    ...props
  });
});
Trigger.defaultProps = {
  align: "top left"
};
export default Trigger;
//# sourceMappingURL=Trigger.js.map